import { render, staticRenderFns } from "./ReportGeneralView.vue?vue&type=template&id=9573580a&"
import script from "./ReportGeneralView.vue?vue&type=script&lang=ts&"
export * from "./ReportGeneralView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports